import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import { getFuncVisitorIndicators } from '@blade-sxp/portrait-center/utils/common-request';
let indicators = class indicators extends Vue {
    dates;
    zoneType;
    isLoading = false;
    numbersBox = [
        {
            label: `${this.$t('visitations')}`,
            value: '-',
            name: 'VISIT_OFFLINE_COUNT',
            helpIcon: false,
        },
        {
            label: `${this.$t('unique')}`,
            value: '-',
            name: 'VISIT_USER_COUNT',
            helpIcon: false,
        },
        {
            label: `${this.$t('returnedVistors')}`,
            value: '-',
            name: 'RETURNED_VISITOR_COUNT',
            helpIcon: true,
        },
    ];
    helpText = '';
    get clusterType() {
        return PortraitCenterModule.clusterType;
    }
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    get sourceType() {
        let value = '';
        if (this.zoneType === 'MAP') {
            value = 'VISIT_USER_COUNT';
        }
        else if (this.zoneType === 'VIRTUAL_AREA') {
            value = 'VA_VISIT_USER_COUNT';
        }
        return value;
    }
    getHelpText() {
        this.helpText = `${this.clusterType === 'offline' ? this.$t('clusterTypeYear') : this.$t('clusterTypeDays')}`;
    }
    onChangeDates() {
        this.fetchData();
    }
    onChangeZoneId() {
        this.fetchData();
    }
    formatterValue(value) {
        return value?.toLocaleString();
    }
    mounted() {
        this.fetchData();
    }
    fetchData() {
        this.reset();
        if (this.zoneId !== 0) {
            this.isLoading = true;
            const [dateStart, dateEnd] = this.dates;
            getFuncVisitorIndicators({
                dateStart,
                dateEnd,
                externalBizFrom: '',
                sourceType: this.sourceType,
                zoneType: this.zoneType,
                businessId: this.zoneId,
            })
                .then((res) => {
                let resArray = res;
                this.numbersBox = this.numbersBox.map((item) => {
                    item.value = resArray.find((ele) => {
                        return ele.name === item.name;
                    })?.value;
                    return item;
                });
            })
                .finally(() => {
                this.isLoading = false;
            });
        }
    }
    reset() {
        this.numbersBox = this.numbersBox.map((item) => {
            item.value = '-';
            return item;
        });
    }
};
__decorate([
    Prop()
], indicators.prototype, "dates", void 0);
__decorate([
    Prop()
], indicators.prototype, "zoneType", void 0);
__decorate([
    Watch('clusterType', { immediate: true })
], indicators.prototype, "getHelpText", null);
__decorate([
    Watch('dates')
], indicators.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneId')
], indicators.prototype, "onChangeZoneId", null);
indicators = __decorate([
    Component({
        name: 'indicators',
        i18n: { messages: lang },
    })
], indicators);
export default indicators;
